import styled from 'styled-components';
import {Popup} from 'react-leaflet'


export const SpaceTooltip = ({space}) =>{
    return (
      <div className='flex  flex-col text-md font-bold font-lekton text-center p-5'>
        <div className='px-5 bg-yellow-200'>
        {

        space.url ? 
        
        <a href={space.url} target="_blank" rel="noopener noreferrer" className='text-xl hover:underline text-black'>
        {space.title}
        </a>

        : 
        
        <p className='text-xl hover:underline text-black'>
            {space.title}
        </p>

        }
          <div className='-mt-2'>
            <p className='text-xs'>
              {'Spazio ' + (space.type === "private" ? "Socio" : "Comune")}
            </p>
          </div>
        </div>
        <p className='pt-5 text-center whitespace-pre-line'>
          {space.description}
        </p>
      </div>
    )
}

export const StyledPop = styled(Popup)`
  .leaflet-popup-content-wrapper {
    border-radius: 2;
    padding: 0;
  }
  .leaflet-popup-content p {
    margin:0;
  }
  .leaflet-popup-content {
    margin: 0;
    border-radius: 2;
  }
`;

export const FreeSpaceTooltip = ({space}) =>{
  return (
      <div className='flex  flex-col text-md font-bold font-lekton text-center p-5'>
        <p className='underline mb-2'>Spazio Libero</p>
        <div className='px-5 bg-yellow-200'>
          <p className='bg-yellow-200 text-xl hover:underline'>
            {space.title}
          </p>
          <div className='-mt-2'>
            <p className='bg-yellow-200 text-sm '>
              {'Area ' + space.area}
            </p>
          </div>
        </div>
        <p className='pt-5'>
          {space.description}
        </p>
      </div>
  )
}